export class DocumentTreeCommon { 
    constructor() { }

    public static mapToNodes(item: any, showBin: boolean) {
        const isRoot = !item.id;  // Root library does not have id
        let childLibraries = [];
        if (item.childLibraries) {
            childLibraries = item.childLibraries.map((item: any) => { return this.mapToNodes(item, showBin); });
        }

        return {
            id: item.id,
            hasReadAccess: item.hasReadAccess,
            hasEditAccess: item.hasEditAccess,
            hasCreateAccess: item.hasCreateAccess,
            hasFullAccess: item.hasFullAccess,
            numberOfDocuments: item.numberOfDocuments,
            name: item.name,
            textToSort: item.name || "",
            expanded: item.expanded,
            encoded: false,
            items: childLibraries,
            isAvailable: item.isAvailable,
            enabled: item.IsAvailable && (showBin || !item.isRecycleBin),
            isRecycleBin: item.isRecycleBin
        }
    }

    public static sortOption = { field: "textToSort", dir: "asc" };

    public static sortTree  = (treeview: any): void => {
        
        this.sortNodes(treeview.dataSource.view());
    }

    private static sortNodes(items: any) {
        for (let i = 0; i < items.length; i++) {
            if (items[i].hasChildren) {
                items[i].children.sort(this.sortOption);
                this.sortNodes(items[i].children.view());
            }
        }
    }

    public static initExpandNode(libraryTree: kendo.ui.TreeView) {
        if (libraryTree !== null) {
            libraryTree.element.on("click", ".k-icon", function (e: JQueryEventObject) {
                if (e.target != null && $(e.target).siblings().hasClass("k-state-disabled")) {
                    if (libraryTree != null) {
                        const node = $(e.target).parent().parent() as JQuery<HTMLElement>;

                        if ($(e.target).hasClass("k-i-expand")) {
                            libraryTree.expand(node);
                        }
                        else {
                            libraryTree.collapse(node);
                        }
                    }
                }
            });
        }
    } 

    public static markNode(nodeValue: any, cssClass: string, $treeContainer: any) {
        const $tree = $treeContainer.find("div");
        const treeview = $tree.data("kendoTreeView");
        const dataItem = treeview.dataSource.get(nodeValue);
        if (dataItem) {
            const node = treeview.findByUid(dataItem.uid);
            const kin = node.find('>div span.k-in');
            kin.addClass(cssClass);
        }
    }
}